var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 114,
    viewBox: "0 0 198 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 47,
    width: 16,
    height: 41,
    rx: 8,
    fill: "#B6CAFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 38,
    width: 57,
    height: 38,
    rx: 13.955,
    fill: "#B9E4F2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    width: 111,
    height: 67,
    rx: 13.955,
    fill: "#D6F9EA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 73,
    width: 16,
    height: 41,
    rx: 8,
    fill: "#611C73"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 64,
    width: 57,
    height: 38,
    rx: 13.955,
    fill: "#FE4672"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 26,
    width: 112,
    height: 67,
    rx: 13.955,
    fill: "#D494FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79 26H106.045C113.752 26 120 32.2479 120 39.955V67H92.955C85.2479 67 79 60.7521 79 53.045V26Z",
    fill: "#391A52"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.64c42dca3e417832b86c1691016fb239.svg";
export { ForwardRef as ReactComponent };